import loadable from '@loadable/component';

// 懒加载组件
const DeliveryBalanceQuery = loadable(() => import('./deliveryBalanceQuery/DeliveryBalanceQuery'));
const DeliveryReturnQuery = loadable(() => import('./deliveryReturnQuery/DeliveryReturnQuery'));
const DeliveryModify = loadable(() => import('./deliveryQuery/deliveryModify/DeliveryModify'));
const DeliveryDetailQuery = loadable(() => import('./deliveryDetailQuery/DeliveryDetailQuery'));
const DeliveryQuery = loadable(() => import('./deliveryQuery/DeliveryQuery'));
const DeliveryInvoiceManagement = loadable(() => import('./deliveryInvoiceManagement/DeliveryInvoiceManagement'));
const DeliveryQuery2308 = loadable(() => import('./deliveryQuery2308/DeliveryQuery'));
const DeliveryModify2308 = loadable(() => import('./deliveryQuery2308/deliveryModify/DeliveryModify'));
const DeliveryWithUpstreamQuery = loadable(() => import('./deliveryWithUpstreamQuery/DeliveryQuery'));
const DeliveryWithUpstreamModify = loadable(() => import('./deliveryWithUpstreamQuery/deliveryModify/DeliveryModify'));
const DeliveryReturnWithUpstreamQuery = loadable(() => import('./deliveryReturnWithUpstreamQuery/DeliveryReturnQuery'));
const DeliveryInvoiceWithUpstreamManagement = loadable(() => import('./deliveryInvoiceWithUpstreamManagement/DeliveryInvoiceManagement'));
const DeliveryDetailWithUpstreamQuery = loadable(() => import('./deliveryDetailWithUpstreamQuery/DeliveryDetailQuery'));

export const subRoutes = [
  {
    path: '/DeliveryQuery',
    component: DeliveryQuery
  },
  {
    path: '/DeliveryBalanceQuery',
    component: DeliveryBalanceQuery
  },
  {
    path: '/DeliveryReturnQuery',
    component: DeliveryReturnQuery
  },
  {
    path: '/DeliveryModify',
    component: DeliveryModify
  },
  {
    path: '/DeliveryDetailQuery',
    component: DeliveryDetailQuery
  },
  {
    path: '/DeliveryInvoiceManagement',
    component: DeliveryInvoiceManagement
  },
  {
    path: '/DeliveryQuery2308',
    component: DeliveryQuery2308
  },
  {
    path: '/DeliveryModify2308',
    component: DeliveryModify2308
  },
  {
    // 294002 上游：总务发货单管理
    path: '/DeliveryWithUpstreamQuery',
    component: DeliveryWithUpstreamQuery
  },
  {
    // 294002 上游：总务发货单管理明细修改
    path: '/DeliveryWithUpstreamModify',
    component: DeliveryWithUpstreamModify
  },
  {
    // M294003 上游：总务退货单确认
    path: '/DeliveryReturnWithUpstreamQuery',
    component: DeliveryReturnWithUpstreamQuery
  },
  {
    // 294004 上游：总务发货单发票管理
    path: '/DeliveryInvoiceWithUpstreamManagement',
    component: DeliveryInvoiceWithUpstreamManagement
  },
  {
    // M294006 上游：发货明细查询
    path: '/DeliveryDetailWithUpstreamQuery',
    component: DeliveryDetailWithUpstreamQuery
  }
];
